import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { COMPARISON as C } from '../data/salesAdvisoryData';

const ColumnHead = ({ col, isCurrent, delay }) => (
  <div data-reveal="up-sm" style={{ '--reveal-delay': `${delay}ms` }} className="relative pb-6">
    {isCurrent ? (
      <p data-testid={`compare-head-${col.key}`} className="font-serif text-[24px] lg:text-[28px] leading-tight text-[#B5876C] font-light">{col.name}</p>
    ) : (
      <Link to={col.to} data-testid={`compare-link-${col.key}`} className="group inline-flex items-baseline gap-2 font-serif text-[24px] lg:text-[28px] leading-tight text-[#2E2C28] font-light hover:text-[#B5876C] transition-colors duration-500">
        {col.name}
        <ArrowUpRight size={16} strokeWidth={1.5} className="transition-transform duration-500 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
      </Link>
    )}
    <span aria-hidden="true" className={`line-draw absolute left-0 bottom-0 h-px w-full ${isCurrent ? 'bg-[#B5876C]' : 'bg-[#2E2C28]/40'}`} />
  </div>
);

const Row = ({ row, i }) => (
  <div data-reveal="up-sm" style={{ '--reveal-delay': `${200 + i * 110}ms` }} className="relative grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_minmax(0,2fr)_minmax(0,2fr)] gap-y-4 lg:gap-x-10 py-7 lg:py-8">
    <span aria-hidden="true" className="line-draw absolute left-0 bottom-0 h-px w-full bg-[#d9d2ca]" />
    <p className="text-[12px] tracking-[0.24em] uppercase text-[#8a8378] lg:pt-1">{row.label}</p>
    {row.values.map((v, j) => (
      <div key={j}>
        <p className="lg:hidden text-[11px] tracking-[0.22em] uppercase text-[#B5876C] mb-1.5">{C.columns[j].name}</p>
        <p className="text-base lg:text-[17px] leading-[1.65] text-[#4a463f] font-light text-pretty">{v}</p>
      </div>
    ))}
  </div>
);

export const ServiceComparison = ({ current }) => (
  <div data-testid="service-comparison" className="grid grid-cols-1 lg:grid-cols-12 gap-y-8 lg:gap-x-8">
    <div className="lg:col-span-4" data-reveal="fade">
      <p className="sec-num text-[13px] tracking-[0.28em] uppercase">/ {C.label}</p>
      <h2 className="mt-6 font-serif text-[30px] lg:text-[38px] leading-[1.1] tracking-[-0.01em] text-[#2E2C28] font-light text-balance max-w-[20rem]">{C.heading}</h2>
    </div>
    <div className="lg:col-span-8">
      <div className="hidden lg:grid grid-cols-[minmax(0,1fr)_minmax(0,2fr)_minmax(0,2fr)] gap-x-10">
        <span />
        {C.columns.map((col, j) => <ColumnHead key={col.key} col={col} isCurrent={current === col.key} delay={80 + j * 120} />)}
      </div>
      <div className="lg:hidden flex flex-col gap-4 mb-2">
        {C.columns.map((col, j) => <ColumnHead key={col.key} col={col} isCurrent={current === col.key} delay={j * 100} />)}
      </div>
      {C.rows.map((row, i) => <Row key={row.label} row={row} i={i} />)}
    </div>
  </div>
);
